import React, { forwardRef, useState, useEffect } from "react";

import MaskedInput from "react-text-mask";
import { isValid, parse } from "date-fns";
import { IoClose } from "react-icons/io5";

import {
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";

import { BsCalendarWeek } from "react-icons/bs";

const CustomDatepickerInput = forwardRef((props, ref) => {
  const [showClearButton, setShowClearButton] = useState(false);

  const handleClear = () => {
    props?.setFieldValue("");
    setShowClearButton(false);
    if (props.clear) {
      props.clear();
    }
  };

  useEffect(() => {
    setShowClearButton(props?.fieldValue?.length > 0);
  }, [props?.fieldValue]);

  return (
    <InputGroup onClick={props.onClick}>
      <Input
        {...props}
        minHeight="42px"
        backgroundColor="#F9FAFB"
        autoComplete="off"
        border="1px solid #D7D8DE"
        placeholder={props.customPlaceholder ? props.customPlaceholder : ""}
        ref={ref}
        guide={false}
        w={props?.widthInput}
        mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
        as={MaskedInput}
        display={"block"}
        onChange={(e) => {
          const value = e.target.value;
          setShowClearButton(value?.length > 0);
          props.setFieldValue(value);
          if (value) {
            if (value.length === 10) {
              if (isValid(parse(value, "dd/MM/yyyy", new Date()))) {
                props.onChange(e);
              }
            }
          }
        }}
        {...(props.setIsFocused && {
          onFocus: () => props.setIsFocused(true),
          onBlur: () => props.setIsFocused(false),
        })}
        _placeholder={{ fontSize: ["10px", "12px", "14px"], pr: "2" }}
        value={props.fieldValue}
      />

      <InputRightElement
        zIndex={"0"}
        height={"full"}
        display={"flex"}
        gap={3}
        mr={showClearButton ? 4 : ""}>
        {showClearButton && !props?.disabled && (
          <IconButton
            icon={<IoClose size={16} />}
            color="#999999"
            variant="ghost"
            size={20}
            onClick={handleClear}
            _hover={{ color: "#000" }}
          />
        )}
        <IconButton
          icon={<BsCalendarWeek />}
          color="#000"
          variant="ghost"
          size={20}
          onClick={props.disabled ? null : props.onIconClick}
        />
      </InputRightElement>
    </InputGroup>
  );
});

export default CustomDatepickerInput;
